export default __webpack_public_path__ + "static/media/1298742_foursquare_icon 1.e1637080.svg";